// ###########################################################################
// HEADER - Add class .min to scroll down
$(document).ready(function() {
  $(window).scroll(function() {
    var scrollPosition = $(window).scrollTop();

    if (scrollPosition > 300) {
      $('.main-header').addClass('min');
    } else {
      $('.main-header').removeClass('min');
    }
  });
});

// ###########################################################################
// ANIMATION FADE TO TOP - element dom
// Seuls les éléments pas encore révélés sont mesurés : .active n'est jamais
// retirée, inutile de relire l'offset() des autres à chaque scroll. La liste
// est relue à chaque passage pour attraper les cartes ajoutées après coup
// (clones Slick, « charger plus » des annuaires).
var $window = $(window);

function check_if_in_view() {
    var $animation_elements = $('.animated:not(.active)');
    if (!$animation_elements.length) {
        return;
    }

    var window_height = $window.height();
    var window_top_position = $window.scrollTop();
    var window_bottom_position = (window_top_position + window_height);

    $.each($animation_elements, function() {
        var $element = $(this);
        var element_height = $element.outerHeight();
        var element_top_position = $element.offset().top;
        var element_bottom_position = (element_top_position + element_height);

        if ((element_bottom_position >= window_top_position) &&
            (element_top_position <= window_bottom_position)) {
            $element.addClass('active');
        }
    });
}

// Au plus un calcul par image : le scroll peut tirer bien plus souvent que
// l'écran ne se rafraîchit, et chaque passage force le navigateur à recalculer
// la mise en page (offset, outerHeight).
var inViewQueued = false;
$window.on('scroll resize', function () {
    if (inViewQueued) {
        return;
    }
    inViewQueued = true;
    window.requestAnimationFrame(function () {
        inViewQueued = false;
        check_if_in_view();
    });
});
$window.trigger('scroll');

// ###########################################################################
// BOUCLE D'ANIMATION DES CANVAS
// Les canvas animés (traits du marquee, globe) tournaient en continu, même
// hors écran ou onglet en arrière-plan : le navigateur redessinait deux
// canvas à chaque image pendant toute la visite. Au retour vers le haut de
// page, cette charge s'ajoutait au lecteur vidéo et aux flous du header — la
// page se figeait et des blocs restaient blancs le temps d'être repeints.
// La boucle ne tourne plus que lorsque le canvas est visible.
function canvasLoop(canvas, frame) {
  var visible = true;
  var running = false;

  function tick() {
    if (!visible || document.hidden) {
      running = false;
      return;
    }
    frame();
    window.requestAnimationFrame(tick);
  }

  function start() {
    if (running || !visible || document.hidden) {
      return;
    }
    running = true;
    window.requestAnimationFrame(tick);
  }

  if ('IntersectionObserver' in window) {
    // Marge de 200px : l'animation repart juste avant que le canvas n'entre à
    // l'écran, pour ne pas le montrer figé.
    new IntersectionObserver(function (entries) {
      visible = entries[0].isIntersecting;
      start();
    }, { rootMargin: '200px 0px' }).observe(canvas);
  }

  document.addEventListener('visibilitychange', start);
  start();
}

// ###########################################################################
// PRIMARY NAVIGATION
$("#btnMobile").click(function (e) {
  var isOpen = !$(this).hasClass("cross");

  $(this).toggleClass("cross", isOpen);
  $(".main-nav-wrapper").toggleClass("open", isOpen);
  $("body").toggleClass("overflow", isOpen);

  // Le panneau n'est pas un <details> : sans ça, un lecteur d'écran annonce
  // toujours le burger comme replié.
  $(this)
    .attr("aria-expanded", isOpen ? "true" : "false")
    .attr("aria-label", isOpen ? "Fermer la navigation" : "Ouvrir la navigation");
});

// ###########################################################################
// HERO - couverture vidéo
// Au premier clic, on efface la couverture et on demande la lecture au lecteur
// embarqué. Vimeo et YouTube écoutent tous deux postMessage, mais avec des
// formats de message différents — d'où le test sur l'URL de l'iframe.
$(document).on("click", ".js-hero-poster", function () {
  var $poster = $(this);
  var iframe = $poster.siblings(".block-hero__video-iframe").get(0);

  $poster.addClass("is-hidden");

  // Efface aussi la légende : son dégradé se superpose à la barre de contrôle
  // du lecteur (son, progression, plein écran).
  $poster.closest(".block-hero__video-frame").addClass("is-playing");

  // Et sur la section : l'ombre du cadre et le fondu n'ont plus lieu d'être
  // une fois la vidéo lancée, ils assombrissent son bord gauche.
  $poster.closest(".block-hero").addClass("is-playing");

  if (!iframe || !iframe.contentWindow) {
    return;
  }

  if (iframe.src.indexOf("player.vimeo.com") !== -1) {
    iframe.contentWindow.postMessage(
      JSON.stringify({ method: "play" }),
      "https://player.vimeo.com"
    );
  } else if (iframe.src.indexOf("youtube") !== -1) {
    iframe.contentWindow.postMessage(
      JSON.stringify({ event: "command", func: "playVideo", args: [] }),
      "*"
    );
  }
});

// ###########################################################################
// LINES DIVIDER - bande de traits sous le bandeau marquee
// Reprise de makeDivider() de la maquette : le calcul du tracé (angles,
// vitesses, longueurs, alpha) est identique, seules les sources changent —
// couleurs et sens lus sur l'élément, dimensions prises sur le canvas plutôt
// que sur window, pour que le bloc reste utilisable ailleurs qu'en pleine page.
$(".js-lines-canvas").each(function () {
  var canvas = this;
  var ctx = canvas.getContext && canvas.getContext("2d");
  if (!ctx) {
    return;
  }

  var colors;
  try {
    colors = JSON.parse(canvas.getAttribute("data-colors")) || [];
  } catch (e) {
    colors = [];
  }
  if (!colors.length) {
    return;
  }

  var dir = canvas.getAttribute("data-direction") === "1";

  var lines = colors.map(function (col, i) {
    return {
      col: col,
      angle: ((-5 + i * 1.5) * Math.PI) / 180,
      w: 1.2 + i * 0.1,
      // Décalage de départ, en fraction du cycle. Sans lui, les treize lignes
      // partent toutes du même point hors champ et la bande reste vide le temps
      // qu'elles entrent — c'est le cas dans la maquette.
      phase: i / colors.length
    };
  });

  function resize() {
    canvas.width = canvas.offsetWidth;
    canvas.height = canvas.offsetHeight;
  }
  resize();
  $(window).on("resize", resize);

  // Une bande de traits qui balaie l'écran en continu tombe pile dans ce que
  // ce réglage vise : on dessine une image et on s'arrête.
  var reduceMotion =
    window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  var t = 0;

  function draw() {
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    var cycle = canvas.width * 1.6;

    lines.forEach(function (l, i) {
      var spd = 0.5 + i * 0.08;

      // Modulo normalisé : en JS, -100 % 300 vaut -100 et non 200. Sans cette
      // remise dans [0, cycle[, le sens inverse sortait les lignes du cadre au
      // lieu de les faire réapparaître.
      var travel = t * spd * (dir ? -1 : 1) + l.phase * cycle;
      var off = (((travel % cycle) + cycle) % cycle) - canvas.width * 0.3;

      var cx = off;
      var cy = canvas.height / 2;
      var len = canvas.width * 0.4 + i * 15;

      ctx.beginPath();
      ctx.moveTo(cx, cy);
      ctx.lineTo(cx + Math.cos(l.angle) * len, cy + Math.sin(l.angle) * len);
      ctx.strokeStyle = l.col;
      ctx.lineWidth = l.w;
      ctx.globalAlpha = 0.4;
      ctx.stroke();
      ctx.globalAlpha = 1;
    });
  }

  // Mouvement réduit : une image fixe, redessinée si le canvas est
  // redimensionné (changer sa largeur l'efface).
  if (reduceMotion) {
    draw();
    $(window).on("resize", draw);
    return;
  }

  canvasLoop(canvas, function () {
    draw();
    t += 0.9;
  });
});

// ###########################################################################
// GLOBE - colonne "Chiffre" du bloc content-1-1
// Reprise de drawGlobe() de la maquette : sphère, latitudes, méridiens
// colorés, trois orbites à points mobiles, pin Namur, puis le chiffre au
// centre et son intitulé. Le calcul du tracé est inchangé ; seules les
// sources varient — chiffre, intitulé et couleurs lus sur l'élément.
$(".js-globe-canvas").each(function () {
  var canvas = this;
  var gx = canvas.getContext && canvas.getContext("2d");
  if (!gx) {
    return;
  }

  var colors;
  try {
    colors = JSON.parse(canvas.getAttribute("data-colors")) || [];
  } catch (e) {
    colors = [];
  }
  if (colors.length < 9) {
    return;
  }

  var numberText = canvas.getAttribute("data-number") || "";
  var labelText = (canvas.getAttribute("data-label") || "").toUpperCase();

  // La maquette dessine en double densité pour rester net sur écran retina.
  function resize() {
    canvas.width = canvas.offsetWidth * 2;
    canvas.height = canvas.offsetHeight * 2;
  }
  resize();
  $(window).on("resize", resize);

  var reduceMotion =
    window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  var gt = 0;

  function drawGlobe() {
    gx.clearRect(0, 0, canvas.width, canvas.height);

    var cx = canvas.width / 2;
    var cy = canvas.height / 2;
    var r = Math.min(cx, cy) * 0.52;

    // Sphère
    gx.beginPath();
    gx.arc(cx, cy, r, 0, Math.PI * 2);
    gx.strokeStyle = "rgba(255,255,255,0.1)";
    gx.lineWidth = 1.5;
    gx.stroke();

    // Latitudes
    for (var i = 1; i < 5; i++) {
      var lat = (i / 5 - 0.5) * Math.PI;
      var yr = cy + r * Math.sin(lat);
      var xr = r * Math.cos(lat);
      gx.beginPath();
      gx.ellipse(cx, yr, xr, xr * 0.3, 0, 0, Math.PI * 2);
      gx.strokeStyle = "rgba(255,255,255,0.05)";
      gx.lineWidth = 0.8;
      gx.stroke();
    }

    // Méridiens colorés
    for (var m = 0; m < 6; m++) {
      var ph = (m / 6) * Math.PI + gt * 0.25;
      gx.beginPath();
      for (var a = 0; a <= Math.PI * 2; a += 0.06) {
        var x3 = cx + r * Math.sin(a) * Math.cos(ph);
        var y3 = cy + r * Math.cos(a);
        if (a === 0) {
          gx.moveTo(x3, y3);
        } else {
          gx.lineTo(x3, y3);
        }
      }
      gx.strokeStyle = colors[m * 2];
      gx.globalAlpha = 0.09;
      gx.lineWidth = 0.6;
      gx.stroke();
      gx.globalAlpha = 1;
    }

    // Trois orbites avec leur point mobile
    [r * 1.28, r * 1.55, r * 1.82].forEach(function (or, idx) {
      var col = colors[idx * 3];
      gx.beginPath();
      gx.ellipse(cx, cy, or, or * 0.3, 0, 0, Math.PI * 2);
      gx.strokeStyle = col;
      gx.globalAlpha = 0.18;
      gx.lineWidth = 0.9;
      gx.stroke();
      gx.globalAlpha = 1;

      var ang = gt * (idx === 0 ? 1 : idx === 1 ? -0.65 : 0.42) + idx * 2.1;
      var dx = Math.cos(ang) * or;
      var dy = Math.sin(ang) * or * 0.3;
      gx.beginPath();
      gx.arc(cx + dx, cy + dy, 5, 0, Math.PI * 2);
      gx.fillStyle = col;
      gx.fill();
      gx.beginPath();
      gx.arc(cx + dx, cy + dy, 11, 0, Math.PI * 2);
      gx.strokeStyle = col;
      gx.globalAlpha = 0.2;
      gx.lineWidth = 1.2;
      gx.stroke();
      gx.globalAlpha = 1;
    });

    // Pin Namur
    gx.beginPath();
    gx.arc(cx + 14, cy - 22, 6, 0, Math.PI * 2);
    gx.fillStyle = "#c10a27";
    gx.fill();
    gx.beginPath();
    gx.arc(cx + 14, cy - 22, 12, 0, Math.PI * 2);
    gx.strokeStyle = "#c10a27";
    gx.globalAlpha = 0.22;
    gx.lineWidth = 1.2;
    gx.stroke();
    gx.globalAlpha = 1;

    // Halo derrière le chiffre, pour qu'il reste lisible sur les méridiens
    var grad = gx.createRadialGradient(cx, cy, 0, cx, cy, r * 0.55);
    grad.addColorStop(0, "rgba(10,10,15,0.6)");
    grad.addColorStop(1, "rgba(10,10,15,0)");
    gx.fillStyle = grad;
    gx.beginPath();
    gx.arc(cx, cy, r * 0.9, 0, Math.PI * 2);
    gx.fill();

    // Chiffre
    var pulse = 1 + Math.sin(gt * 1.2) * 0.018;
    gx.save();
    gx.translate(cx, cy);
    gx.scale(pulse, pulse);
    gx.font = "900 " + r * 1.1 + "px 'Space Grotesk', sans-serif";
    gx.textAlign = "center";
    gx.textBaseline = "middle";
    gx.shadowColor = "#009984";
    gx.shadowBlur = r * 0.35;
    gx.fillStyle = "rgba(255,255,255,0.08)";
    gx.fillText(numberText, 2, 6);
    gx.shadowBlur = 0;
    var tg = gx.createLinearGradient(-r * 0.5, -r * 0.5, r * 0.5, r * 0.5);
    tg.addColorStop(0, "#67bea3");
    tg.addColorStop(0.5, "#009984");
    tg.addColorStop(1, "#008bcb");
    gx.fillStyle = tg;
    gx.fillText(numberText, 0, 0);
    gx.restore();

    // Intitulé
    if (labelText) {
      gx.font = "500 " + r * 0.16 + "px 'Space Grotesk', sans-serif";
      gx.textAlign = "center";
      gx.textBaseline = "middle";
      gx.fillStyle = "rgba(255,255,255,0.45)";
      gx.fillText(labelText, cx, cy + r * 0.68);
    }
  }

  if (reduceMotion) {
    drawGlobe();
    $(window).on("resize", drawGlobe);
    return;
  }

  canvasLoop(canvas, function () {
    drawGlobe();
    gt += 0.009;
  });
});

// ###########################################################################
// SUBNAV NAVIGATION
$("ul > li.menu-item-has-children > a").click(function (e) {
    e.preventDefault();
    var LiParent =$(this).parent().attr('class');
    if(! LiParent.includes("openSub-menu") ){
        $('ul > li.menu-item-has-children > a').parent().removeClass("openSub-menu");
    }
    $(this).parent().toggleClass("openSub-menu");
});

// CLOSE NAV WHEN CLICK ANYWHERE
$(document).on("click", function (event) {
    var $trigger = $(".menu-item-has-children");
    if ($trigger !== event.target && !$trigger.has(event.target).length) {
        $(".menu-item-has-children").removeClass("openSub-menu");
    }
});

// ###########################################################################
// ANCRE
$('a[href^="#"]').on('click',function (e) {
    e.preventDefault();

    var nav = $('nav');
    var target = this.hash,
    $target = $(target);

    $('html, body').stop().animate({
        'scrollTop': $target.offset().top - nav.height()
    }, 1200, 'swing', function () {
        window.location.hash = target;
    });
});

// ###########################################################################
// SLICK - slideshow & slider
if (typeof $.fn.slick !== 'undefined') {
  $(document).ready(function(){

    $('.slideshow .slider-wrapper').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 4000,
      infinite: true,
      cssEase: 'ease',
      fade: true,
      speed: 1000,
    });

    // Colonne « Galerie photo » du bloc content-1-1.
    $('.block-content-1-1__gallery-slider').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      infinite: true,
      adaptiveHeight: false,
      speed: 400
    });

    // Grille de partenaires — le PHP n'ajoute la classe qu'au-delà de 2 entrées.
    // 4 visibles sur desktop, 3 sur tablette, 2 sur mobile : Slick retire les
    // flèches de lui-même aux paliers où tout tient déjà à l'écran.
    $('.js-partners-slider').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      arrows: true,
      dots: false,
      infinite: true,
      speed: 400,
      responsive: [
        {
          breakpoint: 992,
          settings: { slidesToShow: 3 }
        },
        {
          breakpoint: 768,
          settings: { slidesToShow: 2 }
        }
      ]
    });

  });
}

// ###########################################################################
// FANCYBOX - ouverture des galeries photo en grand (data-fancybox)
if (typeof Fancybox !== 'undefined') {
  Fancybox.bind('[data-fancybox]', {});
}